export var AnalyticsId;
(function (AnalyticsId) {
    AnalyticsId["settingsButton"] = "google-analytics-watcher-settings-button";
    AnalyticsId["settingsContainer"] = "google-analytics-watcher-settings-container";
    AnalyticsId["upload"] = "google-analytics-watcher-upload";
    AnalyticsId["translate"] = "google-analytics-watcher-translate";
    AnalyticsId["getLinkButton"] = "google-analytics-watcher-get-link-button";
    AnalyticsId["downloadButton"] = "google-analytics-watcher-download-button";
})(AnalyticsId || (AnalyticsId = {}));
